<template>
    <div>
      <div class="loading-spinner-outer" v-if="saving">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Saving, please wait
          </div>
        </div>
      </div>
        <div class="box">
            <div class="box-content">
                <div style="max-width: 500px;">
                    <div class="form-group">
                        <label>Address Line 1</label>
                        <input type="text" name="line_1" v-model="address.line_1" class="form-control" required>
                    </div>
                    <div class="form-group">
                        <label>Address Line 2</label>
                        <input type="text" name="line_2" v-model="address.line_2" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Town</label>
                        <input type="text" name="town" v-model="address.town" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>County</label>
                        <input type="text" name="county" v-model="address.county" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Postcode</label>
                        <input type="text" name="postcode" v-model="address.postcode" class="form-control" required>
                    </div>
                    <div class="align-right">
                        <a class="btn-primary" @click.stop.prevent="save()">
                            Update Address
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'company_id',
      'address',
      'logged_in_user',
    ],
    data() {
      return {
        saving: false,
      }
    },
    methods: {
      save() {

        const validationErrors = Validate({
          line_1: this.address.line_1,
          town: this.address.town,
          county: this.address.county,
          postcode: this.address.postcode,
        }, {
          line_1: {
            presence: {
              allowEmpty: false,
            },
          },
          town: {
            presence: {
              allowEmpty: false,
            },
          },
          county: {
            presence: {
              allowEmpty: false,
            },
          },
          postcode: {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to save address',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        this.saving = true;

        if(this.address.postcode.toLowerCase() === "ireland") {
          this.address.northings = 20;
          this.address.eastings = 20;
          this.saveAddress();
        } else {
          axios.get(`https://api.postcodes.io/postcodes/${this.address.postcode}`).then((response) => {

            if(response.data.result.country === 'Northern Ireland') {
              this.address.northings = 20;
              this.address.eastings = 20;
            } else {
              this.address.northings = response.data.result.northings;
              this.address.eastings = response.data.result.eastings;
            }

            this.saveAddress();

          }).catch(() => {
            this.saving = false;
            Swal.fire({
              title: 'Invalid Postcode',
              icon: 'warning',
            });
          });
        }
      },
      saveAddress(){
        axios.post(`/company/update-address`, {
          address: this.address,
        }).then((response) => {
          Swal.fire({
            title: 'Address Updated',
            icon: 'success',
          });

          window.location.href = `/company/${this.company_id}/address`;

        });
      }
    },
  };
</script>
